module.exports = __webpack_public_path__ + "img/MP-Logo-Dark.55d02096.svg";